<div class="modal-header">
  <h4 class="modal-title">
    {{ mode === 'after-expired' ? 'Обновяване на обява' : 'Копиране на обява' }}
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="closeModal()">
  </button>
</div>
<div class="modal-body">
  <section class="mb-4 alert bg-primary-subtle">
    <p class="m-0">
      @if (mode === 'after-expired') {
        <p class="m-0">
          При обновяване на обява се задава нова крайна дата, до която искате обявата да бъде активна. Останалата
          информация ще се запази без промяна.
        </p>
      } @else {
        <p class="m-0">
          При копиране на обява ще бъде създадена нова обява с нова крайна дата, а цялата останала информация ще бъде
          копирана от оригиналната.
        </p>
      }
    </p>
  </section>
  <p><strong class="text-muted">Обява: </strong>{{ adTitle }}</p>
  <form [formGroup]="form">
    <div class="mb-3 row g-4">
      <div class="col-12">
        <label for="endDate" class="mb-0 form-label">Крайна дата и час*</label>
        <div class="input-group">
          <input
            ngbDatepicker
            id="endDate"
            name="endDate"
            formControlName="endDate"
            #endDatepicker="ngbDatepicker"
            placeholder="Изберете дата (дд.мм.гггг)"
            [minDate]="endDateMinDate"
            [maxDate]="endDateMaxDate"
            class="form-control rounded-start-1"
            [class.border-success]="endDate?.touched && endDate?.valid"
            [class.border-danger]="endDate?.touched && endDate?.invalid"/>
          <button
            type="button"
            [disabled]="endDatepicker.disabled"
            class="btn btn-outline-secondary"
            (click)="endDatepicker.toggle()">
            <i class="fa-regular fa-calendar-days"></i>
          </button>
        </div>
        @if (endDate?.touched && endDate?.invalid) {
          <small class="text-danger">Задължително поле във формат дд.мм.гггг!</small>
        }
      </div>
      <div class="col-12 col-md-6">
        <span class="form-label">Час*</span>
        <ng-select
          [clearable]="false"
          [searchable]="false"
          [items]="hourOptions"
          bindValue="value"
          bindLabel="label"
          formControlName="endHour"
          notFoundText="Няма намерени часове"
          placeholder="Изберете час"
          [class.is-valid]="endHour?.touched && endHour?.valid"
          [class.is-invalid]="endHour?.touched && endHour?.invalid">
        </ng-select>
        @if (endHour?.touched && endHour?.invalid) {
          <p class="m-0 invalid-feedback">Задължително поле!</p>
        }
      </div>
      <div class="col-12 col-md-6">
        <span class="form-label">Минути*</span>
        <ng-select
          [clearable]="false"
          [searchable]="false"
          [items]="minutesOptions"
          bindValue="value"
          bindLabel="label"
          formControlName="endMinutes"
          notFoundText="Няма намерени минути"
          placeholder="Изберете минути"
          [class.is-valid]="endMinutes?.touched && endMinutes?.valid"
          [class.is-invalid]="endMinutes?.touched && endMinutes?.invalid">
        </ng-select>
        @if (endMinutes?.touched && endMinutes?.invalid) {
          <p class="m-0 invalid-feedback">Задължително поле!</p>
        }
      </div>
    </div>
  </form>
</div>
<div class="modal-footer d-block text-end">
  <button
    type="button"
    class="me-2 btn btn-outline-secondary"
    (click)="closeModal()">
    <span>Затвори</span>
  </button>
  <button
    type="button"
    [disabled]="loading"
    class="btn btn-nz-primary"
    (click)="onSubmit()">
    @if (loading) {
      <span class="me-2 spinner-border spinner-border-sm"></span>
    }
    @if (mode === 'after-expired') {
      <span>Обнови</span>
    } @else {
      <span>Копирай</span>
    }
  </button>
</div>
